import { Categories, CategoryTypes, Flavor } from 'Constants/storeTypes';
import { UserRoles } from 'Constants/userRoles';
import { AppService } from 'AppServices/appService';
const { getUserDivisions } = new AppService();

const state = {
  roimaticConfiguration: null,
  freshChatRestoreId: null,
  freshChatExternalId: null,
  hqFranchiseStores: null,
  userDivisions: null,
  isProductConfigModified: false,
  hasOneDraftCampaign: false,
  selectedCampaignId: null
};

const getters = {
  roimaticConfiguration: state => state.roimaticConfiguration,
  roimaticCategory: state =>
    state.roimaticConfiguration
      ? state.roimaticConfiguration.category
      : 'e-commerce',
  roimaticFlavour: state =>
    state.roimaticConfiguration
      ? state.roimaticConfiguration.flavor
      : 'shopify',
  deltaXFeedStatus: state =>
    state.roimaticConfiguration.productFeed
      ? state.roimaticConfiguration.productFeed.processingInfo
        .deltaXFeedStatus
      : null,
  isForCreativeBuilder: state =>
    state.roimaticConfiguration &&
        state.roimaticConfiguration.category ==
            CategoryTypes.find(a => a.id === Categories.CreativeBuilder)
              .category,
  isForRichMediaAdBuilder: state =>
    state.roimaticConfiguration &&
      state.roimaticConfiguration.category ==
          CategoryTypes.find(a => a.id === Categories.RichMediaAdBuilder)
            .category,
  freshChatExternalId: (state, getters, rootState, rootGetters) => {
    return state.roimaticConfiguration && state.roimaticConfiguration.freshChatExternalId
      ? state.roimaticConfiguration.freshChatExternalId
      : rootGetters.businessDetails && rootGetters.businessDetails.freshChatExternalId ? rootGetters.businessDetails.freshChatExternalId : localStorage.getItem('freshChatExternalId')
  },
  freshChatRestoreId: (state, getters, rootState, rootGetters) => {
    return state.roimaticConfiguration && state.roimaticConfiguration.freshChatRestoreId
      ? state.roimaticConfiguration.freshChatRestoreId
      : rootGetters.businessDetails && rootGetters.businessDetails.freshChatRestoreId ? rootGetters.businessDetails.freshChatRestoreId : localStorage.getItem('freshChatRestoreId')
  },
  isEcommerce: state => Boolean(state.roimaticConfiguration && state.roimaticConfiguration.category === CategoryTypes.find(ct => ct.id === Categories.ECommerce).category),
  isLocalBusiness: state => Boolean(state.roimaticConfiguration && state.roimaticConfiguration.category === CategoryTypes.find(ct => ct.id === Categories.LocalBusiness).category),
  isHqFranchise: state => Boolean(state.roimaticConfiguration && state.roimaticConfiguration.category === CategoryTypes.find(ct => ct.id === Categories.HqFranchise).category),
  isAutoFlavour: (state, getters) => getters.isHqFranchise && getters.roimaticFlavour == Flavor.auto,
  hqFranchiseStores: state =>state.hqFranchiseStores,
  isBrandPortal: state => Boolean(state.roimaticConfiguration && state.roimaticConfiguration.category === CategoryTypes.find(ct => ct.id === Categories.BrandPortal).category),
  userDivisions: state => state.userDivisions,
  isProductConfigModified: state => state.isProductConfigModified,
  hasOneDraftCampaign: state => state.hasOneDraftCampaign,
  selectedCampaignId: state => state.selectedCampaignId
};

const actions = {
  setRoimaticConfiguration(context, payload) {
    context.commit('setRoimaticConfiguration', payload);
  },
  setHqFranchiseStores(context, payload){
    context.commit('setHqFranchiseStores', payload);
  },
  setStoreInsights(context, payload) {
    context.commit('setStoreInsights', payload);
  },
  async setUserDivisions(context){
    let user = JSON.parse(localStorage.getItem('user'));
    let portal = JSON.parse(localStorage.getItem('portal'));
    if(user.roleIds && !user.roleIds.includes(UserRoles.BrandManager)){
      // if user is not brand manager then don't fetch any divisions
      context.commit('setUserDivisions', []);
      return;
    }
    try{
      let divisions = await getUserDivisions(user.id, portal.id);
      context.commit('setUserDivisions', divisions);
    }catch(error){
      context.commit('setUserDivisions', []);
    }
  },
  setHasOneDraftCampaign(context, payload) {
    context.commit('setHasOneDraftCampaign', payload);
  },
  setSelectedCampaignId(context, payload) {
    context.commit('setSelectedCampaignId', payload);
  }
};

const mutations = {
  setRoimaticConfiguration(state, payload) {
    state.roimaticConfiguration = payload;
  },
  setHqFranchiseStores(state, payload){
    state.hqFranchiseStores = payload;
  },
  setStoreInsights(state, payload){
    payload.forEach(insight => {
      state.hqFranchiseStores.find(e => e.id == insight.storeId).cost = insight.insights.metricInsights[0].value;
      state.hqFranchiseStores.find(e => e.id == insight.storeId).costToBeSpent = insight.insights.metricInsights[1].value;
    });;
  },
  setUserDivisions(state, payload){
    state.userDivisions = payload;
  },
  productConfigModified(state, isProductConfigModified){
    state.isProductConfigModified = isProductConfigModified;
  },
  setHasOneDraftCampaign(state, hasOneDraftCampaign){
    state.hasOneDraftCampaign = hasOneDraftCampaign;
  },
  setSelectedCampaignId(state, selectedCampaignId) {
    state.selectedCampaignId = selectedCampaignId;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
